import { ExporterWorkspaceMembershipRole } from "./exporter-workspace-membership-role";
import { z } from "zod";
export const ExporterWorkspaceMembership = z.object({
    id: z.string(),
    workspaceId: z.string(),
    exporterId: z.string(),
    role: ExporterWorkspaceMembershipRole,
});
